function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { Component } from 'react';
import OwnersListItem from "./OwnersListItem";
import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles(theme => ({
  root: {
    display: "block"
  }
}));

const OwnersList = ({
  className,
  owners = undefined,
  children,
  onSelect
}) => {
  const classes = useStyles();
  return React.createElement("section", {
    className: className || classes.root
  }, owners && owners.length && owners.map((owner, index) => {
    return React.createElement(OwnersListItem, _extends({}, owner, {
      onClick: () => onSelect(owner),
      key: index
    }));
  }), children);
};

export default OwnersList;